import styled from 'styled-components';
import { Flex } from 'utils/style';

import DatePicker from 'components/form/DatePicker/container';

export default styled(DatePicker)`
  ${Flex.row};
`;
